import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';

/** Search box with magnifier + clear button, matching the list-page UI. */
const SearchInput = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  size = 'md',
  className = '',
  /** When true, matches the FilterBar field (h-10, 10px radius, #E9EDF6 border, #FAFBFE fill). */
  filterBarMatch = false,
  ...rest
}) => (
  <div className={`relative ${className}`}>
    <MagnifyingGlassIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#9aa3ab]" />
    <input
      type="text"
      value={value}
      onChange={(e) => onChange && onChange(e.target.value, e)}
      placeholder={placeholder}
      className={`${filterBarMatch ? 'h-10' : size === 'sm' ? 'h-8' : 'h-9'} w-full ${
        filterBarMatch
          ? 'rounded-[10px] border border-[#E9EDF6] bg-[#FAFBFE] placeholder:text-[#637381]'
          : 'rounded-lg border border-[#d0d5dd] bg-white placeholder:text-[#9aa3ab]'
      } pl-9 ${
        value ? 'pr-8' : 'pr-3'
      } text-sm text-[#212B36] focus:border-[#0061B2] focus:outline-none focus:ring-2 focus:ring-[#0061B2]/15`}
      {...rest}
    />
    {value && (
      <button
        type="button"
        aria-label="Clear search"
        onClick={(e) => onChange && onChange('', e)}
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-[#9aa3ab] hover:bg-slate-100 hover:text-[#212B36]"
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    )}
  </div>
);

export default SearchInput;
